import { Endpoints } from "../constants/endpoint";

// GET all prompts
export const GetAllPrompts = async () => {
  try {
    const res = await fetch(Endpoints.prompts); // e.g., "/prompt/"
    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    const data = await res.json();
    return data;
  } catch (err) {
    return err.message;
  }
};

// GET prompt by ID
export const GetPromptById = async (id) => {
  try {
    const res = await fetch(`${Endpoints.prompts}${id}`); // "/prompt/<id>"
    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    const data = await res.json();
    return data;
  } catch (err) {
    return err.message;
  }
};

// POST create prompt
export const CreatePrompt = async (payload) => {
  const options = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json;charset=utf-8",
    },
    body: JSON.stringify(payload),
  };

  try {
    const res = await fetch(Endpoints.prompts); // "/prompt/"
    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    const data = await res.json();
    return data;
  } catch (err) {
    return err.message;
  }
};

// PUT update prompt
export const EditPrompt = async (id, payload) => {
  const options = {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json;charset=utf-8",
    },
    body: JSON.stringify(payload),
  };

  try {
    const res = await fetch(`${Endpoints.prompts}${id}`, options);
    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    const data = await res.json();
    return data;
  } catch (err) {
    return err.message;
  }
};

// DELETE prompt
export const DeletePrompt = async (id) => {
  const options = {
    method: "DELETE",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json;charset=utf-8",
    },
  };

  try {
    const res = await fetch(`${Endpoints.prompts}${id}`, options);
    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    const data = await res.json(); // expected: { deleted: true }
    return data;
  } catch (err) {
    return err.message;
  }
};
